<svg>
	<use [attr.href]="path"></use>
</svg>
